import { manager } from "./protos/eb.manager"
import { Observable,  merge, bindCallback, Subscription, Subject, NEVER } from "rxjs"
import { filter, map, throwIfEmpty } from "rxjs/operators"
import { IEBManagerConnector } from "./managerConnector"
import { loginfo, logerr } from "./utils"

const modName = "stats-collector"
const EVENTCLASS = manager.ArgumentsEvent.EventClass
const ACTIONS = manager.ArgumentsEvent.Actions
interface IStatsCollector {
  register(sp: IStatsInputPlugin): IStatsCollector
  registerOutput(iop: IStatsOutputPlugin, name: string): IStatsCollector
  unregisterOutput(name: string): void
  close(): void
}

interface IStatsInputPlugin {
  subscribeEvents(): Subject<manager.Message>
}

// IStatsOutput is the interface that gives the ability of feeding the to any backend
// However it should be able to extract the stats from a manager.Message
interface IStatsOutputPlugin {
  next(event: manager.Message): void // this function is called by statsCollector
  stop(): any
}

const createStatsCollector = () => {
  return new StatsCollector()
}
class StatsCollector implements IStatsCollector {

  private eventSubject: Subject<manager.Message> = new Subject<manager.Message>()
  private mapOutputPlugin: Map<string, [Subscription, IStatsOutputPlugin]> =
    new Map<string, [Subscription, IStatsOutputPlugin]>()
  // register registers an input plugin
  public register = (plugin: IStatsInputPlugin): StatsCollector => {
    // construct the eventSubject
    // this.eventSubject = merge(plugin.subscribeEvents(), this.eventSubject)
    // this.bindEventStream()
    plugin.subscribeEvents().subscribe({
      next: (msg) => {
        this.eventSubject.next(msg)
      },
    })
    return this
  }


  public close = (): void => {
    // remove all the output
    this.mapOutputPlugin.forEach((value, key) => {
      value[1].stop()
      value[0].unsubscribe()
    })
  }

  public registerOutput = (outputPlugin: IStatsOutputPlugin, name: string): IStatsCollector => {
    if (this.mapOutputPlugin.has(name)) { console.warn("Duplicated op: ", name); return this }
    this.mapOutputPlugin.set(name, [this.eventSubject.pipe(
      filter((evt) => evt.Type !== undefined),
      filter((evt) => evt.Type === manager.MessageType.MessageTypeEvent),
      map((evt) => {
        const result = manager.Message.verify(evt)
        if (result !== "null" && result !== null) {
          loginfo(modName, evt)
          logerr(modName, result)
        }
        return evt
      }),
      // filter the resource events
    ).subscribe({
      next: outputPlugin.next,
    }), outputPlugin])
    return this
  }

  public unregisterOutput = (name: string): void => {
    if (this.mapOutputPlugin.has(name)) {
      this.mapOutputPlugin.get(name)[0].unsubscribe()
    }
  }
}

export {
  IStatsInputPlugin,
  StatsCollector,
  createStatsCollector,
  IStatsCollector,
  IStatsOutputPlugin,
}
